module.exports = __webpack_public_path__ + "fonts/071dbbd.TTF";